import React, { useEffect, useState } from "react";
import withRouter from "components/Common/withRouter";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Button,
  Table,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import axios from "axios";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

const API_BASE = "https://mansethaberapi.stechomeyazilim.com";
const API_TITLES = `${API_BASE}/BILDIRIM_BASLIKLARI`;
const API_TITLES_LIST = `${API_TITLES}?$format=json&$top=200&$orderby=SIRA asc`;

const SOUND_OPTIONS = [
  { value: "default", label: "Varsayılan" },
  { value: "breaking", label: "Son Dakika" },
  { value: "soft", label: "Yumuşak" },
  { value: "chime", label: "Çan" },
];

const emptyForm = { ID: null, BASLIK: "", TIP: "", SES: "default", SIRA: "", AKTIF: true, RENK: "#0d6efd", IKON: "" };

const NotificationTitles = () => {
  document.title = "Bildirim Başlıkları | Manşet Haber ADMIN PANELI";

  const [titles, setTitles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(emptyForm);

  const showToast = (success, message) => {
    toastr.options = {
      positionClass: "toast-top-right",
      timeOut: 5000,
      closeButton: true,
      progressBar: true,
    };
    if (success) toastr.success(message, "Başarılı");
    else toastr.error(message, "Hata");
  };

  const fetchTitles = async () => {
    setLoading(true);
    try {
      const res = await fetch(API_TITLES_LIST);
      const json = await res.json();
      setTitles(json && Array.isArray(json.value) ? json.value : []);
    } catch (error) {
      console.error("Başlıklar alınamadı:", error);
      setTitles([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTitles();
  }, []);

  const openNew = () => {
    setForm(emptyForm);
    setModal(true);
  };

  const openEdit = (item) => {
    setForm({
      ID: item.ID,
      BASLIK: item.BASLIK || "",
      TIP: item.TIP || "",
      SES: item.SES || "default",
      SIRA: item.SIRA != null ? item.SIRA : "",
      AKTIF: item.AKTIF !== false,
      RENK: item.RENK || "#0d6efd",
      IKON: item.IKON || "",
    });
    setModal(true);
  };

  const toggleModal = () => setModal((m) => !m);

  const handleChange = (field, value) => {
    setForm((f) => ({ ...f, [field]: value }));
  };

  const slugify = (txt) =>
    (txt || "")
      .toLowerCase()
      .replace(/ı/g, "i")
      .replace(/ş/g, "s")
      .replace(/ğ/g, "g")
      .replace(/ü/g, "u")
      .replace(/ö/g, "o")
      .replace(/ç/g, "c")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

  const handleSave = async () => {
    if (!form.BASLIK.trim()) {
      showToast(false, "Başlık metni zorunludur.");
      return;
    }
    setSaving(true);
    const payload = {
      BASLIK: form.BASLIK.trim(),
      TIP: (form.TIP || "").trim() || slugify(form.BASLIK),
      SES: form.SES || "default",
      SIRA: form.SIRA === "" ? null : Number(form.SIRA),
      AKTIF: !!form.AKTIF,
      RENK: form.RENK || null,
      IKON: (form.IKON || "").trim() || null,
    };
    try {
      if (form.ID) {
        await axios.put(`${API_TITLES}(${form.ID})`, payload);
        showToast(true, "Başlık güncellendi.");
      } else {
        await axios.post(API_TITLES, payload);
        showToast(true, "Başlık eklendi.");
      }
      setModal(false);
      fetchTitles();
    } catch (error) {
      console.error("Kaydetme hatası:", error);
      showToast(false, "Kaydetme işlemi başarısız oldu.");
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Bu başlığı silmek istediğinize emin misiniz?")) return;
    try {
      await axios.delete(`${API_TITLES}(${id})`);
      showToast(true, "Başlık silindi.");
      fetchTitles();
    } catch (error) {
      console.error("Silme hatası:", error);
      showToast(false, "Silme işlemi başarısız oldu.");
    }
  };

  const toggleActive = async (item) => {
    try {
      await axios.patch(`${API_TITLES}(${item.ID})`, { AKTIF: !(item.AKTIF !== false) });
      fetchTitles();
    } catch (error) {
      console.error("Durum değiştirme hatası:", error);
      showToast(false, "Durum değiştirilemedi.");
    }
  };

  // Başlığı listede yukarı/aşağı taşı; SIRA değerlerini yeniden numaralandırır.
  const handleMove = async (index, direction) => {
    const target = index + direction;
    if (target < 0 || target >= titles.length) return;

    const reordered = [...titles];
    const [moved] = reordered.splice(index, 1);
    reordered.splice(target, 0, moved);

    // Anlık UI güncellemesi (beklemeden)
    setTitles(reordered.map((t, i) => ({ ...t, SIRA: i + 1 })));

    try {
      // Sadece SIRA'sı değişenleri güncelle
      await Promise.all(
        reordered.map((t, i) => {
          const yeniSira = i + 1;
          if (t.SIRA === yeniSira) return null;
          return axios.patch(`${API_TITLES}(${t.ID})`, { SIRA: yeniSira });
        })
      );
    } catch (error) {
      console.error("Sıralama hatası:", error);
      showToast(false, "Sıralama kaydedilemedi.");
      fetchTitles();
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Bildirim Başlıkları" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="card-title mb-0">Standart Bildirim Başlıkları</h5>
                    <Button color="success" onClick={openNew}>
                      <i className="mdi mdi-plus me-1" /> Yeni Başlık
                    </Button>
                  </div>
                  <p className="text-muted">
                    Buradaki başlıklar bildirim gönderim ekranındaki "Bildirim Başlığı"
                    listesinde görünür. Bir başlık seçildiğinde varsayılan sesi otomatik uygulanır.
                  </p>

                  <div className="table-responsive">
                    <Table className="table-nowrap align-middle mb-0">
                      <thead>
                        <tr>
                          <th style={{ width: 60 }}>Sıra</th>
                          <th>Başlık</th>
                          <th>Tip</th>
                          <th>Ses</th>
                          <th>Durum</th>
                          <th className="text-end">İşlemler</th>
                        </tr>
                      </thead>
                      <tbody>
                        {titles.map((item, index) => (
                          <tr key={item.ID}>
                            <td>
                              <div className="d-flex align-items-center gap-1">
                                <div className="d-flex flex-column">
                                  <Button
                                    color="link"
                                    className="p-0 lh-1"
                                    disabled={index === 0}
                                    onClick={() => handleMove(index, -1)}
                                    title="Yukarı taşı"
                                  >
                                    <i className="mdi mdi-chevron-up font-size-18" />
                                  </Button>
                                  <Button
                                    color="link"
                                    className="p-0 lh-1"
                                    disabled={index === titles.length - 1}
                                    onClick={() => handleMove(index, 1)}
                                    title="Aşağı taşı"
                                  >
                                    <i className="mdi mdi-chevron-down font-size-18" />
                                  </Button>
                                </div>
                                <span>{item.SIRA != null ? item.SIRA : "-"}</span>
                              </div>
                            </td>
                            <td className="fw-medium">
                              <span className="d-inline-flex align-items-center gap-2">
                                <span
                                  style={{
                                    display: "inline-block",
                                    width: 12,
                                    height: 12,
                                    borderRadius: "50%",
                                    backgroundColor: item.RENK || "#adb5bd",
                                  }}
                                />
                                {item.IKON && <i className={`mdi ${item.IKON}`} />}
                                {item.BASLIK}
                              </span>
                            </td>
                            <td>
                              <Badge color="info" className="font-size-11">
                                {item.TIP || "-"}
                              </Badge>
                            </td>
                            <td className="text-muted">{item.SES || "default"}</td>
                            <td>
                              <Badge
                                color={item.AKTIF !== false ? "success" : "secondary"}
                                style={{ cursor: "pointer" }}
                                onClick={() => toggleActive(item)}
                              >
                                {item.AKTIF !== false ? "Aktif" : "Pasif"}
                              </Badge>
                            </td>
                            <td className="text-end">
                              <Button
                                color="primary"
                                size="sm"
                                className="me-2"
                                onClick={() => openEdit(item)}
                              >
                                <i className="mdi mdi-pencil" />
                              </Button>
                              <Button
                                color="danger"
                                size="sm"
                                onClick={() => handleDelete(item.ID)}
                              >
                                <i className="mdi mdi-delete" />
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>

                  {loading && (
                    <div className="text-center mt-3">
                      <Spinner color="primary" />
                    </div>
                  )}
                  {!loading && titles.length === 0 && (
                    <div className="text-center mt-4 text-muted">
                      Henüz tanımlı başlık yok. "Yeni Başlık" ile ekleyebilirsiniz.
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal isOpen={modal} toggle={toggleModal} centered>
        <ModalHeader toggle={toggleModal}>
          {form.ID ? "Başlığı Düzenle" : "Yeni Başlık Ekle"}
        </ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="fBaslik">Başlık Metni</Label>
              <Input
                id="fBaslik"
                value={form.BASLIK}
                onChange={(e) => handleChange("BASLIK", e.target.value)}
                placeholder="Örn. Son Dakika"
              />
            </FormGroup>
            <FormGroup>
              <Label for="fTip">Tip (Etiket)</Label>
              <Input
                id="fTip"
                value={form.TIP}
                onChange={(e) => handleChange("TIP", e.target.value)}
                placeholder="Boş bırakılırsa başlıktan üretilir (örn. son-dakika)"
              />
            </FormGroup>
            <FormGroup>
              <Label for="fSes">Varsayılan Ses</Label>
              <Input
                type="select"
                id="fSes"
                value={form.SES}
                onChange={(e) => handleChange("SES", e.target.value)}
              >
                {SOUND_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </Input>
            </FormGroup>
            <div className="row">
              <FormGroup className="col-6">
                <Label for="fRenk">Renk</Label>
                <Input
                  type="color"
                  id="fRenk"
                  value={form.RENK || "#0d6efd"}
                  onChange={(e) => handleChange("RENK", e.target.value)}
                  style={{ height: 38, padding: 4 }}
                />
              </FormGroup>
              <FormGroup className="col-6">
                <Label for="fIkon">İkon (mdi)</Label>
                <Input
                  id="fIkon"
                  value={form.IKON}
                  onChange={(e) => handleChange("IKON", e.target.value)}
                  placeholder="örn. mdi-fire"
                />
                {form.IKON && (
                  <small className="text-muted">
                    Önizleme: <i className={`mdi ${form.IKON}`} />
                  </small>
                )}
              </FormGroup>
            </div>
            <FormGroup>
              <Label for="fSira">Sıra</Label>
              <Input
                type="number"
                id="fSira"
                value={form.SIRA}
                onChange={(e) => handleChange("SIRA", e.target.value)}
                placeholder="Boş bırakılırsa otomatik"
              />
            </FormGroup>
            <FormGroup check className="mb-0">
              <Input
                type="checkbox"
                id="fAktif"
                checked={!!form.AKTIF}
                onChange={(e) => handleChange("AKTIF", e.target.checked)}
              />
              <Label for="fAktif" check>
                Aktif (gönderim ekranında görünsün)
              </Label>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="light" onClick={toggleModal} disabled={saving}>
            İptal
          </Button>
          <Button color="success" onClick={handleSave} disabled={saving}>
            {saving ? (
              <>
                <Spinner size="sm" className="me-1" /> Kaydediliyor...
              </>
            ) : (
              "Kaydet"
            )}
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default withRouter(NotificationTitles);
